import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchVidanges = createAsyncThunk("vidanges/fetchAll", async ({ kmAvantAlerte = 5000, page = 1, pageSize = 10 } = {}, { rejectWithValue }) => {
  try { const r = await api.get('/Vidange', { params: { kmAvantAlerte, page, pageSize } }); return r.data; } // PagedResult
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const createVidange = createAsyncThunk("vidanges/create", async (data, { rejectWithValue }) => {
  try {
    await api.post('/Vidange', data);
    const list = await api.get('/Vidange', { params: { kmAvantAlerte: 5000, page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  } catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const updateVidange = createAsyncThunk("vidanges/update", async ({ id, data }, { rejectWithValue }) => {
  try { await api.patch(`/Vidange/${id}`, data); return { id, ...data }; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const deleteVidange = createAsyncThunk("vidanges/delete", async (id, { rejectWithValue }) => {
  try { await api.delete(`/Vidange/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

const slice = createSlice({
  name: "vidanges",
  initialState: {
    items: [],
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSuccess: (state) => { state.success = false; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVidanges.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchVidanges.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(fetchVidanges.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(createVidange.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createVidange.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = 1;
        state.success = true;
      })
      .addCase(createVidange.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(updateVidange.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(updateVidange.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.items.findIndex(i => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = { ...state.items[idx], ...action.payload };
        state.success = true;
      })
      .addCase(updateVidange.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(deleteVidange.fulfilled, (state, action) => {
        state.items = state.items.filter(i => i.id !== action.payload);
        state.totalCount = Math.max(0, state.totalCount - 1);
        state.success = true;
      })
      .addCase(deleteVidange.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { resetSuccess, clearError } = slice.actions;
export default slice.reducer;
